import * as inflection from 'inflection';
import React from 'react';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';
import postPath from '../../utils/url/postPath';
import * as styles from './ImportFilesConfirmation.module.scss';

const IMPORTED_FILES_FRAGMENT = gql(`
  fragment ImportFilesConfirmation_importedFiles on ImportedFile {
    filename
    post {
      id
      title
    }
  }
`);

interface ImportFilesConfirmationProps {
  importedFiles: DocumentType<typeof IMPORTED_FILES_FRAGMENT>[];
}

const ImportFilesConfirmation = ({
  importedFiles,
}: ImportFilesConfirmationProps) => {
  const succeeded = importedFiles.filter(({ post }) => !!post);
  const failed = importedFiles.filter(({ post }) => !post);
  const total = succeeded.length;

  if (total === 0) {
    return (
      <div>
        There was nothing found to import. Please check the file you uploaded.
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div>
        All done! We imported {total} {inflection.inflect('post', total)} for
        you.
        <ul>
          {succeeded.map(({ post }) => (
            <li key={post.id}>
              <Link to={postPath(post)} newTab>
                {post.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {failed.length ? (
        <div>
          Failed to import:
          <ul>
            {failed.map(({ filename }) => (
              <li key={filename}> {filename} </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default ImportFilesConfirmation;
